import React from "react";
import styles from "../css/Landing.module.css";

function Landing({ onEnter }) {
  return (
    <div className={styles.landingContainer}>
      <div className={styles.content}>
        <h1 className={styles.title}>
          {'SERENADE'.split('').map((letter, index) => {
            if (letter === 'A' || letter === 'a') {
              return (
                <span key={index} className={styles.stylizedA}>
                  <span className={styles.triangleA}>△</span>
                </span>
              );
            }
            return <span key={index}>{letter}</span>;
          })}
        </h1>
        <button className={styles.enterButton} onClick={onEnter}>
          ENTER
        </button>
      </div>
    </div>
  );
}

export default Landing;

